import { Actions } from './actions';

export const interact = (context: any, reaction: any) => {
    const { log } = context;
    return (state: any) => (next: any) => (action: any) => {
        // default processing
        let result = next(action);

        // trigger reaction
        const { type } = result;
        log.debug(
            'one-state-interact-state',
            'interact middleware', {
                action,
                result,
            }
        );

        if ((type === Actions.SET) ||
            (type === Actions.RESET)) {
            log.debug(
                'one-state-interact-voice',
                'interact middleware, triggering reaction',{
                    action,
                    result,
                }
            );
            const { getState, dispatch } = state;
            reaction(context, getState, dispatch);
        }

        // return the action
        // [redux docs]
        return result;
    }
}
